export interface PollOption {
  label?: string;
}

export interface PollBlockData {
  '@type'?: 'poll';
  question?: string;
  description?: string;
  options?: PollOption[];
}

export const PollSchema = () => ({
  title: 'Enquete',
  fieldsets: [
    {
      id: 'default',
      title: 'Configurações',
      fields: ['question', 'description', 'options'],
    },
  ],
  properties: {
    question: {
      title: 'Pergunta',
      placeholder: 'Digite a pergunta da enquete',
      type: 'string',
    },
    description: {
      title: 'Descrição',
      description: 'Texto auxiliar exibido abaixo da pergunta (opcional).',
      placeholder: 'Ex: Escolha uma opção para participar da pesquisa.',
      type: 'string',
      widget: 'textarea',
    },
    options: {
      title: 'Opções',
      description: 'Adicione entre 2 e 10 opções de resposta.',
      type: 'array',
      widget: 'object_list',
      minLength: 2,
      maxLength: 10,
      schema: {
        title: 'Texto da opção',
        fieldsets: [{ id: 'default', title: 'Opção', fields: ['label'] }],
        properties: {
          label: { title: 'Texto da opção' },
        },
        required: ['label'],
      },
    },
  },
  required: ['question', 'options'],
});
